import React, { Component } from 'react';
import { connect } from 'react-redux';

class FloridaSalesTax extends Component {
  render() {
    const { floridaSalesTax } = this.props;
    return (
      <div className="Row Title-feeRow">

        <input
          id="Sales"
          type="text"
          value={floridaSalesTax || '0.00'}
          readOnly
          className="Row-total"
          tabIndex="-1"
        />

        <b>Florida Sales Tax</b>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    floridaSalesTax: state.salestaxes.floridaSalesTax,
  };
};

export default connect(mapStateToProps)(FloridaSalesTax);



// WEBPACK FOOTER //
// ./src/containers/salestaxes/FloridaSalesTax.js